import TravelReports from "../../components/travel-reports";

export default TravelReports;